import {Component, ReactNode} from 'react';
import {perfLogger} from './buried/performance';
import weirwood from './weirwood';
import loadError from '@/assets/img/loadError.png';
import {LOG_DOC_TYPE, LogDocType} from '@/buried/performance/const';
import * as store from '@/store';

interface ErrorBoundaryProps {
  docType?: LogDocType;
  children?: ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
}
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error: Error) {
        try {
            const captureError = perfLogger.captureError;
            const docType = this.props.docType || LOG_DOC_TYPE.doc;
            const docMode = store.getDocumentMode();
            if (typeof error === 'string' || !error) {
                error = new Error(error);
            }
            error.message = `editorCrash ${docType} ${docMode} ${error.message}`;
            weirwood && weirwood.error.captureException(error);
            // 未被try catch住的error
            captureError.captureError(error, captureError.ERROR_TYPE.unCapturedError);
            perfLogger.editorCrash.logWeb(error, docType);
        } catch (err) {
            console.error('err: ', err);
        }
    }
    handleRefresh = () => {
        location.reload();
    };
    render() {
        if (this.state.hasError) {
            // 你可以自定义降级后的 UI 并渲染
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginTop: 214,
                    }}
                >
                    <img
                        style={{width: 160, height: 160}}
                        src={loadError}
                    />
                    <div
                        style={{
                            marginTop: 16,
                            fontSize: 14,
                            color: '#878D99',
                        }}
                    >
                        <span>文档加载失败，请刷新重试！</span>
                        <span
                            style={{color: '#3377FF', cursor: 'pointer'}}
                            onClick={this.handleRefresh}
                        >
                            立即刷新
                        </span>
                    </div>
                    {/* <div
                        style={{
                            fontSize: 14,
                            color: '#999',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '80px',
                        }}
                    >页面加载失败，请刷新重试!</div> */}
                </div>
            );
        }

        return this.props.children;
    }
}
